import { SafeArea } from 'capacitor-plugin-safe-area';
import { Plugin } from 'vue';

export const CapacitorSafeAreaPlugin = {
  async install() {
    SafeArea.getSafeAreaInsets().then((data) => {
      const { insets } = data;
      document.documentElement.style.setProperty('--ion-safe-area-top', `${insets.top}px`);
      console.log('--ion-safe-area-top', `${insets.top}px`);
      document.documentElement.style.setProperty(
        '--ion-safe-area-right',
        `${insets.right}px`,
      );
      console.log('--ion-safe-area-right',
        `${insets.right}px`);
      document.documentElement.style.setProperty(
        '--ion-safe-area-bottom',
        `${insets.bottom}px`,
      );
      console.log('--ion-safe-area-bottom',
        `${insets.bottom}px`);
      document.documentElement.style.setProperty(
        '--ion-safe-area-left',
        `${insets.left}px`,
      );
      console.log('--ion-safe-area-left',
        `${insets.left}px`);
    });
  },
} as Plugin;
